module.exports = __webpack_public_path__ + "img/0.61ccc9ad.png";